import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { AuthService } from "./auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const token = auth.token();
  if (token && !req.headers.has("X-Skip-Auth")) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        const url = router.url;
        void auth.logout().then(() =>
          router.navigate(["/login"], {
            queryParams: url && url !== "/login" ? { redirect: url } : {},
          }),
        );
      }
      return throwError(() => err);
    }),
  );
};
